import { authApi } from "./auth.api";
import { setDeviceAndLocationPayload } from "./auth.slice";
import { getDeviceAndLocationPayload } from "../../utils/getDeviceDetails.utils";

export const deviceLocationMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (
    authApi.endpoints.studentLoginOTP.matchFulfilled(action) ||
    authApi.endpoints.studentLoginAdmissionID.matchFulfilled(action)
  ) {
    const deviceAndLocation = store.getState().auth.deviceAndLocation;

    // Check if deviceAndLocation is missing or has any "N/A" or null values
    const needsRefresh =
      !deviceAndLocation ||
      deviceAndLocation.city === "N/A" ||
      deviceAndLocation.city === null ||
      deviceAndLocation.state === "N/A" ||
      deviceAndLocation.state === null ||
      deviceAndLocation.pincode === "N/A" ||
      deviceAndLocation.pincode === null ||
      deviceAndLocation.webType === "N/A" ||
      deviceAndLocation.webType === null ||
      deviceAndLocation.ip_address === "N/A" ||
      deviceAndLocation.ip_address === null ||
      deviceAndLocation.latitude === null ||
      deviceAndLocation.longitude === null;

    if (needsRefresh) {
      getDeviceAndLocationPayload()
        .then((deviceAndLocationData) => {
          store.dispatch(setDeviceAndLocationPayload(deviceAndLocationData));
        })
        .catch((error) => {
          console.error("Error fetching device and location data:", error);
        });
    }
  }

  return result;
};
